// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyC_B9drKJAtqhfeJPn8odtuLreWCJC1C3I",
    authDomain: "meeting-tracker-bdbb8.firebaseapp.com",
    projectId: "meeting-tracker-bdbb8",
    storageBucket: "meeting-tracker-bdbb8.appspot.com",
    messagingSenderId: "988809558364",
    appId: "1:988809558364:web:167c29e32532a507b72999",
    measurementId: "G-106FP6FSSZ"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
